export const createCoalescedTask = (task) => {
  let pending = null;
  let requested = false;
  return () => {
    requested = true;
    if (!pending) {
      pending = Promise.resolve().then(async () => {
        try {
          do {
            requested = false;
            await task();
          } while (requested);
        } finally {
          pending = null;
        }
      });
    }
    return pending;
  };
};
